export default "__VITE_ASSET__C$jD776J__"